const getAd = (doc) => doc.content
  .replace(/(<([^>]+)>)/gi, '')
  .split('companyName: ')[0]
  .trim();

const getCsvContent = (docs) => docs.reduce((csv, doc) => {
  const ad = getAd(doc);
  return `${csv}"${ad}"\r\n`;
}, '');

const getPdfContent = (docs) => docs.reduce((pdf, doc) => {
  const ad = getAd(doc);
  return `${pdf}"${ad}"\r\n\n`;
}, '');

const getTxtContent = (docs) => docs.reduce((txt, doc) => {
  const ad = getAd(doc);
  return `${txt}"${ad}"\r\n\n`;
}, '');

export { getTxtContent, getPdfContent, getCsvContent };
